<template>
  <div class="ts-strip" v-tip="'Estimated from Speed and CT, everyone starting even. Gear Haste/Slow counts; Haste or Slow cast mid-fight doesn\'t.'">
    <span class="ts-lbl">Turn order</span>
    <div class="ts-row">
      <span v-for="(t, i) in order" :key="i" class="ts-turn" :style="{ '--tc': t.bright }">
        <b>{{ i + 1 }}</b>
        <UnitSprite :unit="t.unit" :team-color="t.pal" :fallback-src="t.fallback" :flip="t.left" :size="38" />
        <span class="ts-name">{{ t.name }}</span>
        <i v-if="t.haste" v-tip="'Haste from gear (×3/2 Speed)'">⏫</i><i v-else-if="t.slow" v-tip="'Slow from gear (×1/2 Speed)'">⏬</i>
      </span>
    </div>
  </div>
</template>

<script>
// The spotlight's estimated turn order for the match: the first 12 turns across both teams (lib/turnOrder's CT/Speed
// clock), with gear-granted Haste or Slow counted. Was the old Fight View's strip.
import UnitSprite from '../UnitSprite.vue';
import { unitCombatStats } from '../../lib/unitStats.js';
import { turnOrder } from '../../lib/turnOrder.js';
import { UNITS_BASE } from '../../lib/assetUrls.js';

export default {
  name: 'TurnStrip',
  components: { UnitSprite },
  props: {
    l: { type: Object, required: true },   // spotlight sides: { label, bright, pal, units }
    r: { type: Object, required: true },
    gd: { type: Object, required: true },
  },
  computed: {
    order() {
      const mk = (u, side, left) => {
        let cs = null;
        try { cs = unitCombatStats(u, this.gd.charStats, this.gd.itemschanged, this.gd.notAbles); } catch (e) { cs = null; }
        const st = [];
        if (cs) for (const item of Object.values(cs.equipped)) for (const s of [...(item.permstatus || []), ...(item.initstatus || [])]) st.push(s.name);
        const haste = st.includes('Haste'), slow = !haste && st.includes('Slow');
        let speed = cs ? cs.stats.speed : 0;
        if (haste) speed = Math.floor((speed * 3) / 2); else if (slow) speed = Math.floor(speed / 2);
        return { name: u.Name, unit: u, speed, haste, slow, left, bright: side.bright, pal: side.pal, fallback: this.portrait(u, side.label) };
      };
      // ties go L1, R1, L2, R2, …, so the rosters interleave
      const L = this.l.units || [], R = this.r.units || [], all = [];
      for (let i = 0; i < Math.max(L.length, R.length); i++) { if (L[i]) all.push(mk(L[i], this.l, true)); if (R[i]) all.push(mk(R[i], this.r, false)); }
      return turnOrder(all, 12);
    },
  },
  methods: {
    portrait(u, label) {
      if (u.Gender === 'Monster') return UNITS_BASE + u.Class + '.gif';
      const g = (u.Gender || 'Male')[0];
      return label === 'Champion' ? UNITS_BASE + u.Class + g + '.gif' : UNITS_BASE + u.Class + g + '_' + label + '.gif';
    },
  },
};
</script>

<style scoped>
.ts-strip { display: flex; align-items: center; gap: 10px; padding: 6px 12px; background: var(--navy2); border-top: 1px solid var(--brass-edge); }
.ts-lbl { flex: none; font-family: var(--cond); font-weight: 700; font-size: 12px; letter-spacing: 1.6px; text-transform: uppercase; color: var(--brass); }
.ts-row { display: flex; gap: 4px; overflow-x: auto; scrollbar-width: thin; }
.ts-turn { flex: none; display: flex; align-items: center; gap: 3px; padding: 1px 7px 1px 4px; border-radius: 3px; border-bottom: 2px solid var(--tc); background: rgba(255, 255, 255, 0.04); font-size: 12.5px; white-space: nowrap; }
.ts-turn b { font-family: var(--cond); color: var(--brass); font-size: 12px; min-width: 12px; text-align: right; }
.ts-name { color: var(--ink-hi); max-width: 96px; overflow: hidden; text-overflow: ellipsis; }
.ts-turn i { font-style: normal; font-size: 11px; }
</style>
